import { useCallback } from "react"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3"

export default function useRecaptchaToken() {
  const siteKey = process.env.REACT_APP_RECAPTCHA_WEB_KEY
  const required = Boolean(siteKey)
  const { executeRecaptcha } = useGoogleReCaptcha()

  const getToken = useCallback(
    async (action) => {
      if (!required) {
        throw new Error("reCAPTCHA site key is not configured")
      }
      if (!executeRecaptcha) {
        throw new Error("reCAPTCHA is not ready yet")
      }
      return executeRecaptcha(action)
    },
    [executeRecaptcha, required]
  )

  return {
    required,
    ready: !required || Boolean(executeRecaptcha),
    getToken,
  }
}
